module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "map-area section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "mapBox",
    attrs: {
      "id": "mapBox",
      "data-lat": "40.701083",
      "data-lon": "-74.1522848",
      "data-zoom": "13",
      "data-info": "PO Box CT16122 Collins Street West, Victoria 8007, Australia.",
      "data-mlat": "40.701083",
      "data-mlon": "-74.1522848"
    }
  })])])])]), _vm._v(" "), _c('section', {
    staticClass: "contact-form section-padding3"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 mb-5 mb-lg-0"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "into-icon"
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_c('h4', [_vm._v("California, United States")]), _vm._v(" "), _c('p', [_vm._v("Santa monica bullevard")])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "into-icon"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_c('h4', [_vm._v("00 (440) 9865 562")]), _vm._v(" "), _c('p', [_vm._v("Mon to Fri 9am to 6 pm")])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "into-icon"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_c('h4', [_vm._v("support@colorlib.com")]), _vm._v(" "), _c('p', [_vm._v("Send us your query anytime!")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter your name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter your name'",
      "required": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "email",
      "placeholder": "Enter email address",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter email address'",
      "required": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter subject",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter subject'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('textarea', {
    attrs: {
      "name": "message",
      "cols": "20",
      "rows": "7",
      "placeholder": "Enter Message",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter Message'",
      "required": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "template-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("subscribe now")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21d01aff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ContactUs.vue
// module id = 287
// module chunks = 1